import { useEffect, useContext } from 'react';  
import { useNavigate, useLocation } from 'react-router-dom';  
import { AuthContext } from '../contexts/AuthContext';  
  
const API_KEY = 'fea70320-ccf3-493b-b43b-d75f9235f0d6';  
const APPLICATION_NAME = 'MemeBot';  
const API_URL = 'https://authentication.api.ceo.ai';  
  
export default function XCallback() {  
  const { login } = useContext(AuthContext);  
  const navigate = useNavigate();  
  const location = useLocation();  
  
  useEffect(() => { 
    console.log('got to x callback') 
    const handleCallback = async () => {  
      const params = new URLSearchParams(location.search);  
      const code = params.get('code') 
      const state = params.get('state');  
  
      // // Verify state matches  
      // if (state !== localStorage.getItem('state')) {  
      //   navigate('/login');  
      //   return;  
      // }  
  
      try {  
        const response = await fetch(`${API_URL}`, {  
          method: 'POST',  
          headers: {  
            'Content-Type': 'application/json',  
          },  
          body: JSON.stringify({  
            authType: 'twitter',  
            apiKey: API_KEY,  
            applicationName: APPLICATION_NAME,  
            code
          })  
        });  
  
        const data = await response.json();
        console.log('return data: ' + JSON.stringify(data))  
  
        if (data.data?.token && data.data?.user) {  
          login(data.data.user, data.data.token);  
          navigate('/dashboard');  
        } else {  
          navigate('/login');  
        }  
      } catch (error) {  
        navigate('/login');  
      }  
    };  
  
    handleCallback();  
  }, []);  
  
  return <div>Processing login...</div>;  
}  